import { useParams } from "react-router-dom";
import { users } from "../../context/users";

function Profile() {
  const { id } = useParams();
  const user = users.find((u) => u.id === id);

  return user ? (
    <div>
      <h1>{user.name}</h1>
      <p>شغل: {user.job}</p>
      <p>ایمیل: {user.email}</p>
    </div>
  ) : (
    <h2>کاربر پیدا نشد!</h2>
  );
}

export default Profile;
